import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SLIDES = [
  {
    src: "https://static.prod-images.emergentagent.com/jobs/ff2aa6ee-3336-4a00-a5f5-8947729eb7b7/images/c5e352c15488632a91f4dae7a4322963b33885864638ba9df494f2604b999084.jpeg",
    title: "Richmond Parking Lot",
    meta: "Defence Construction Canada — Richmond, BC",
    slug: "richmond-parking-lot",
  },
  {
    src: "/projects/pacific-earthworks/1.jpg",
    title: "Lockblock Walls — Pacific Earthworks",
    meta: "Heavy Earthworks — Lower Mainland, BC",
    slug: "lockblock-wall-sumas-mountain",
  },
  {
    src: "/projects/pavilion-road-lillooet/1.jpg",
    title: "West Pavilion Road — 56 KM",
    meta: "Remote Road Works — Lillooet, BC",
    slug: "pavilion-road-lillooet",
  },
];

export const FeaturedStrip = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive((a) => (a + 1) % SLIDES.length), 4500);
    return () => clearInterval(t);
  }, []);

  const slide = SLIDES[active];

  return (
    <section data-testid="featured-strip" className="border-b-2 border-black bg-black relative overflow-hidden">
      <div className="relative h-[340px] sm:h-[440px]">
        <AnimatePresence mode="sync">
          <motion.img
            key={active}
            src={slide.src}
            alt={slide.title}
            initial={{ opacity: 0, scale: 1.06 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ opacity: { duration: 0.8 }, scale: { duration: 5, ease: "linear" } }}
            className="absolute inset-0 w-full h-full object-cover img-gray"
          />
        </AnimatePresence>
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-black/40 pointer-events-none" />

        <div className="absolute top-0 left-0 m-5 bg-[#FF4F00] text-black font-mono text-[10px] tracking-[0.3em] uppercase px-2 py-1">
          FROM THE FIELD
        </div>

        <div className="absolute inset-x-0 bottom-0 p-6 sm:p-10 flex items-end justify-between gap-6 flex-wrap">
          <div>
            <AnimatePresence mode="wait">
              <motion.div
                key={active}
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.4 }}
              >
                <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-neutral-300">{slide.meta}</div>
                <Link
                  to={`/projects/${slide.slug}`}
                  data-testid="featured-strip-link"
                  className="group mt-2 inline-flex items-center gap-3 text-[#F0F0EC]"
                >
                  <span className="font-display text-3xl sm:text-5xl uppercase tracking-tight leading-[0.95]">
                    {slide.title}
                  </span>
                  <ArrowUpRight className="w-6 h-6 text-[#FF4F00] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </Link>
              </motion.div>
            </AnimatePresence>
          </div>
          <div className="flex items-center gap-2 pb-2" data-testid="featured-strip-dots">
            {SLIDES.map((s, i) => (
              <button
                key={s.slug}
                data-testid={`featured-strip-dot-${i}`}
                onClick={() => setActive(i)}
                aria-label={`Show ${s.title}`}
                className={`h-[6px] transition-all duration-500 ${i === active ? "w-10 bg-[#FF4F00]" : "w-5 bg-[#F0F0EC]/40 hover:bg-[#F0F0EC]/70"}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
